import { render, staticRenderFns } from "./SocketsRealTimeTable.vue?vue&type=template&id=47fc2087&scoped=true"
import script from "./SocketsRealTimeTable.vue?vue&type=script&lang=js"
export * from "./SocketsRealTimeTable.vue?vue&type=script&lang=js"
import style0 from "./SocketsRealTimeTable.vue?vue&type=style&index=0&id=47fc2087&prod&lang=scss"
import style1 from "./SocketsRealTimeTable.vue?vue&type=style&index=1&id=47fc2087&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fc2087",
  null
  
)

export default component.exports